export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/mgJHvYidGqFQfeHMjQQ2pj/PAGINA_4.png',
    alt: 'Sample page Quality Cannot Be Tested Into a Product, explaining why quality must be built into every step',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/m8ih2WFa3Gbpg4PjVNfmq2/PAGINA_9.png',
    alt: 'Sample page Oral Solids Are the Backbone of Most Plants, covering tablets, capsules, powders and granules',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/m7C3QtpGGC6Xxip2jGAWDD/PAGINA_17.png',
    alt: 'Sample page A Tablet Travels Through the Plant in a Fixed Order, showing the ten-step production flow of a tablet plant',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nypjEgHqRN5K7aSsmBpoZH/PAGINA_28.png',
    alt: 'Sample page A Balance Is Trusted Only After It Has Been Checked, covering balance checks and double verification',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/d3S2jwdQBaMQaEy4erwhEB/PAGINA_36.png',
    alt: 'Sample page The Numbers Must Close, a worked example of yield and reconciliation for a tablet batch',
  },
];
